<div class="modal-header">
  <h5 class="modal-title text-center">
    <span>{{ title }}</span>
  </h5>
  <button type="button" class="close" (click)="decline()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ng-content></ng-content>
</div>
<div class="modal-footer">
  <div class="left-side">
    <button type="button" class="btn btn-app-default" (click)="decline()">
      <span>{{ cancelText }}</span>
    </button>
  </div>
  <div class="divider"></div>
  <div class="right-side">
    <button type="button" class="btn btn-app-primary" (click)="confirm()" *ngIf="hasSubmitButton" [disabled]="disabledSubmit">
      <span>{{ submitText }}</span>
    </button>
  </div>
</div>
